<template>
<div class="teachingStatistics">
  <div class="module">
    <div class="item" style="width: 49.5%">
      <div class="title">本学期教学任务</div>
      <div class="content">
        <div class="teachingNumber">
          <div v-for="item in teachingNumberData">
            <p class="num">{{item.sl}}</p>
            <p class="text">{{item.jxwd}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="item" style="width: 49.5%">
      <div class="title">各单位承担课程分布</div>
      <div class="content" id="courseDistribute">

      </div>
    </div>
  </div>
  <div class="module">
    <div class="item" style="width: 24.5%">
      <div class="title">课程属性分析</div>
      <div class="content" id="courseProperty"></div>
    </div>
    <div class="item" style="width: 24.5%">
      <div class="title">各课程属性课时数</div>
      <div class="content" id="propertyTime"></div>
    </div>
    <div class="item" style="width: 24.5%">
      <div class="title">各课程属性学分分布</div>
      <div class="content" id="propertyCredit"></div>
    </div>
    <div class="item" style="width: 24.5%">
      <div class="title">在校生成绩分析</div>
      <div class="content" id="grade"></div>
    </div>
  </div>
  <div class="module">
    <div class="item" style="width: 49.5%">
      <div class="title">学院/专业间挂科率对比分析</div>
      <el-switch
      style="display: block;position: absolute;right: 25px;top: 25px"
      v-model="postedType"
      active-text="学院"
      inactive-text="专业">
      </el-switch>
      <div class="content" id="posted">

      </div>
    </div>
    <div class="item" style="width: 24.5%">
      <div class="title">挂科率TOP10课程</div>
      <div class="content">
        <div class="rankingList">
          <div class="row">
            <div>排名</div>
            <div>课程名称</div>
            <div>挂科人数</div>
          </div>
          <div class="row" v-for="item in courseData">
            <div>{{item.pm}}</div>
            <div>{{item.kcmc}}</div>
            <div>{{item.gkl}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="item" style="width: 24.5%">
      <div class="title">挂科数TOP10学生</div>
      <div class="content">
        <div class="rankingList">
          <div class="row">
            <div>排名</div>
            <div>姓名</div>
            <div>挂科数</div>
          </div>
          <div class="row" v-for="item in studentData">
            <div>{{item.pm}}</div>
            <div>{{item.xm}}</div>
            <div>{{item.gks}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="module">
    <div class="item" style="width: 39.5%">
      <div class="title">教室分布</div>
      <div class="content" id="classroomDistribution"></div>
    </div>
    <div class="item" style="width: 59.5%">
      <div class="title">教室使用率</div>
      <div class="content" id="classroomUsageRate"></div>
    </div>
  </div>
</div>
</template>

<script>
  import axios from "axios";
  import apiConfig from "../../common/js/api_config";

  export default {
    name: "teachingStatistics",
    data() {
      return{
        staffColor: ['#1F89DF', '#49A3EC', '#6FB7F2', '#91C7AE', '#A2A860', '#91C7AE', '#EEC714', '#EEB814', '#6ABD9D'],
        teachingNumberData: [],
        courseData: [],
        studentData: [],
        coursePropertyData: [
          {
            name: '公共课',
            value: 1000
          },
          {
            name: '专业课',
            value: 500
          },
          {
            name: '专业基础课',
            value: 1000
          }
        ],
        gradeData: [
          {
            name: '优秀',
            value: 10000
          },
          {
            name: '良好',
            value: 1000
          },
          {
            name: '合格',
            value: 100
          },
          {
            name: '不合格',
            value: 100
          }
        ],
        postedType: false,
        zyData: [],
        xyData: []
      }
    },
    watch: {
      postedType(newVal) {
        if (newVal) {
          this.drawPosted(this.xyData)
        } else {
          this.drawPosted(this.zyData)
        }
      }
    },
    methods: {
      // 教学任务统计
      async getTeachingNumberData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jx_bxqjxrwtj')
        this.teachingNumberData = resp.data.data
      },
      //各单位承担课程分布
      async getCourseDistributeData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jx_gdwcdkcskss')
        console.log(resp);
        let kcArray = []
        let kcNumArray = []
        let kcTimeArray = []
        resp.data.data.map(item => {
          kcArray.push(item.dwmc)
          if (item.wd === '课程数') {
            kcNumArray.push(item.sl)
          }
          if (item.wd === '课时数') {
            kcTimeArray.push(item.sl)
          }
        })
        this.drawCourseDistribute(kcArray,kcNumArray,kcTimeArray)
      },
      drawCourseDistribute(kcArray,kcNumArray,kcTimeArray) {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: kcArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 30
            },
            {
              type: 'inside',
              start: 0,
              end: 30
            },

          ],
          series: [
            {
              name: '课程数',
              type: 'bar',
              barWidth: '60%',
              data: kcNumArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
            {
              name: '课时数',
              type: 'bar',
              barWidth: '60%',
              data: kcTimeArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20
            },
          ]
        };
        this.courseDistributeBox.setOption(option)
      },
      // 课程属性分析
      async getCoursePropertyData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jx_kcsxkcs')
        let data = resp.data.data
        data.map(item => {
          item.name = item.kcsx
          item.value = item.kcsl
        })
        this.drawCourseProperty(data)
      },
      drawCourseProperty(data) {
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            formatter: '{b} <br/>{a}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 20,
            top: 0,
            itemWidth: 10,
            itemHeight: 10,
            data: data.map(item => item.name)
          },
          series: [
            {
              name: '课程数',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['45%', '65%'],
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              color: this.staffColor,
              data: data
            }
          ]
        };
        this.coursePropertyBox.setOption(option)
      },
      // 课程属性时间分析
      async getPropertyTimeData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jx_kcsxkss')
        let data = resp.data.data
        data.map(item => {
          item.name = item.kcsx
          item.value = item.kssl
        })
        this.drawPropertyTime(data)
      },
      drawPropertyTime (data) {
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            formatter: '{b} <br/>{a}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 20,
            top: 0,
            itemWidth: 10,
            itemHeight: 10,
            data: data.map(item => item.name)
          },
          series: [
            {
              name: '课时数',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['45%', '65%'],
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              color: this.staffColor,
              data: data
            }
          ]
        };
        this.propertyTimeBox.setOption(option)
      },
      // 课程属性学分分布
      async getPropertyCreditData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jx_kcsxxfs')
        let data = resp.data.data
        data.map(item => {
          item.name = item.kcsx
          item.value = item.xfsl
        })
        this.drawPropertyCredit(data)
      },
      drawPropertyCredit(data) {
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            formatter: '{b} <br/>{a}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 20,
            top: 0,
            itemWidth: 10,
            itemHeight: 10,
            data: data.map(item => item.name)
          },
          series: [
            {
              name: '学分',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['45%', '65%'],
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              color: this.staffColor,
              data: data
            }
          ]
        };
        this.propertyCreditBox.setOption(option)
      },
      // 在校生成绩
      async getGradeData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jx_zxscjfx')
        let data = resp.data.data
        data.map(item => {
          item.name = item.cjwd
          item.value = item.xssl
        })
        this.drawGrade(data)
      },
      drawGrade(data) {
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            formatter: '{b} <br/>{a}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 20,
            top: 0,
            itemWidth: 10,
            itemHeight: 10,
            data: data.map(item => item.name)
          },
          series: [
            {
              name: '人数',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['45%', '65%'],
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              color: this.staffColor,
              data: data
            }
          ]
        };
        this.gradeBox.setOption(option)
      },
      // 挂科率
      async getPostedData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jx_xyzygkldbfx')
        this.xyData = resp.data.data.filter(item => item.wd === '学院')
        this.zyData = resp.data.data.filter(item => item.wd === '专业')
        this.drawPosted(this.zyData)
      },
      drawPosted(data) {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: data.map(element => element.yxzymc),
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 10
            },
            {
              type: 'inside',
              start: 0,
              end: 10
            },

          ],
          series: [
            {
              name: '挂科率',
              type: 'bar',
              barWidth: '60%',
              data: data.map(element => element.gkl),
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.postedBox.setOption(option)
      },
      // 挂科课程top
      async getCourseData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jx_gkltop10kc')
        this.courseData = resp.data.data
      },
      // 挂科学生top
      async getStudentData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jx_gkstop10xs')
        this.studentData = resp.data.data
      },
      // 教室分布
      async getClassroomDistributionData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jx_jssl')
        let data = resp.data.data
        data.map(item => {
          item.name = item.jslx
          item.value = item.sl
        })
        this.drawClassroomDistribution(data)
      },
      drawClassroomDistribution (data) {
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            formatter: '{b} <br/>{a}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 20,
            top: 0,
            itemWidth: 10,
            itemHeight: 10,
            data: data.map(item => item.name)
          },
          series: [
            {
              name: '人数',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['45%', '65%'],
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              color: this.staffColor,
              data: data
            }
          ]
        };
        this.classroomDistributionBox.setOption(option)
      },
      // 教室使用率

      async getClassroomUsageRateData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_jx_jssyl')
        let jsArray = []
        let lylArray = []
        resp.data.data.map(item => {
          jsArray.push(item.jslx)
          lylArray.push(item.syl)
        })
        this.drawClassroomUsageRate(jsArray, lylArray)
      },
      drawClassroomUsageRate (jsArray, lylArray) {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: jsArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 100
            },
            {
              type: 'inside',
              start: 0,
              end: 100
            },

          ],
          series: [
            {
              name: '使用率',
              type: 'bar',
              barWidth: '60%',
              data: lylArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.classroomUsageRateBox.setOption(option)
      }
    },
    mounted() {
      this.courseDistributeBox = this.$echarts.init(document.getElementById('courseDistribute'))
      this.coursePropertyBox = this.$echarts.init(document.getElementById('courseProperty'))
      this.propertyTimeBox = this.$echarts.init(document.getElementById('propertyTime'))
      this.propertyCreditBox = this.$echarts.init(document.getElementById('propertyCredit'))
      this.gradeBox = this.$echarts.init(document.getElementById('grade'))
      this.postedBox = this.$echarts.init(document.getElementById('posted'))
      this.classroomDistributionBox = this.$echarts.init(document.getElementById('classroomDistribution'))
      this.classroomUsageRateBox = this.$echarts.init(document.getElementById('classroomUsageRate'))
      this.getTeachingNumberData()
      this.getCourseDistributeData()
      this.getCoursePropertyData()
      this.getPropertyTimeData()
      this.getPropertyCreditData()
      this.getGradeData()
      this.getPostedData()
      this.getCourseData()
      this.getStudentData()
      this.getClassroomDistributionData()
      this.getClassroomUsageRateData()
      window.addEventListener('resize', () => {
        this.courseDistributeBox.resize()
        this.coursePropertyBox.resize()
        this.propertyTimeBox.resize()
        this.propertyCreditBox.resize()
        this.gradeBox.resize()
        this.postedBox.resize()
        this.classroomDistributionBox.resize()
        this.classroomUsageRateBox.resize()
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .teachingStatistics
    width 100%
    color #333
    .module
      width 100%
      height 350px
      margin-top 25px
      display flex
      justify-content space-between
      .item
        width 49.5%
        height 100%
        background #fff
        border-radius 10px
        overflow hidden
        position relative
        .title
          width 100%
          height 20%
          display flex
          align-items center
          justify-content center
          font-size 18px
          font-weight bold
        .content
          width 100%
          height 80%
          .teachingNumber
            width 100%
            height 100%
            display flex
            flex-wrap wrap
            justify-content space-around
            div
              width 25%
              display flex
              flex-direction column
              justify-content center
              align-items center
              .num
                font-size 26px
              .text
                font-size 18px
                margin-top 25px
          .rankingList
            width 100%
            height 100%
            overflow-y scroll
            margin 0 auto
            &::-webkit-scrollbar
              display none
            .row
              width 100%
              height 40px
              display flex
              align-items center
              justify-content space-between
              div
                width 33%
                height 100%
                display flex
                align-items center
                justify-content center
</style>


// WEBPACK FOOTER //
// src/components/datanalysis/teachingStatistics.vue